import { postGoogleIdToken, requestGoogleIdToken } from './google-auth.js';

function getBootstrap() {
  const el = document.getElementById('auth-register-bootstrap');
  if (!el?.textContent) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function setGoogleMode(active, profile) {
  document.body.classList.toggle('pp-register-google-mode', Boolean(active));
  document.querySelectorAll('.pp-auth-reg-password-row').forEach((row) => {
    row.style.display = active ? 'none' : '';
    row.querySelectorAll('input').forEach((input) => {
      if (active) {
        input.removeAttribute('required');
        input.value = '';
      } else {
        input.setAttribute('required', 'required');
      }
    });
  });
  document.querySelectorAll('.pp-auth-reg-google-banner').forEach((el) => {
    el.hidden = !active;
  });

  const emails = document.querySelectorAll(
    '#email_individual, #email_consultant, #email_corporate',
  );
  emails.forEach((input) => {
    if (!input) return;
    if (active && profile?.email) {
      input.value = profile.email;
      input.readOnly = true;
      input.setAttribute('aria-readonly', 'true');
    } else if (!active) {
      input.readOnly = false;
      input.removeAttribute('aria-readonly');
    }
  });

  const firstName = profile?.first_name || profile?.given_name || '';
  const lastName = profile?.last_name || profile?.family_name || '';
  const names = [
    ['#first_name_individual', '#first_name_consultant', '#first_name_corporate', firstName],
    ['#last_name_individual', '#last_name_consultant', '#last_name_corporate', lastName],
  ];
  names.forEach(([a, b, c, val]) => {
    [a, b, c].forEach((sel) => {
      const input = document.querySelector(sel);
      if (input && active && val) input.value = val;
    });
  });
}

export function initRegisterGoogleAuth() {
  const cfg = getBootstrap();
  if (!cfg?.googleAuthEnabled || !cfg.googleClientId) return;

  const btn = document.getElementById('pp-register-google-btn');
  const clearBtn = document.getElementById('pp-register-google-clear');
  if (!btn) return;

  if (cfg.registerGoogle) {
    setGoogleMode(true, cfg.registerGoogle);
  }

  btn.addEventListener('click', async () => {
    btn.disabled = true;
    try {
      const token = await requestGoogleIdToken(cfg.googleClientId);
      const data = await postGoogleIdToken(cfg.registerGooglePrefillUrl, token, cfg.csrfToken);
      setGoogleMode(true, data.profile);
    } catch (err) {
      window.alert(err.message || 'Google ile devam edilemedi.');
    } finally {
      btn.disabled = false;
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', async () => {
      try {
        await fetch(cfg.registerGoogleClearUrl, {
          method: 'POST',
          headers: {
            'X-CSRFToken': cfg.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
        });
        setGoogleMode(false, null);
      } catch {
        /* ignore */
      }
    });
  }
}
